import { useHistory, useLocation } from "react-router";

type QueryParams = Record<string, string | number | boolean>;

export default function useQueryParams(): [URLSearchParams, (params: QueryParams) => void] {
  const history = useHistory();
  const { search } = useLocation();
  const query = new URLSearchParams(search);

  const setQuery = (params) => {
    const newSearch = new URLSearchParams(params);
    history.push({ search: newSearch.toString() });
  };

  return [query, setQuery];
}